<!-- Content -->
<div class="mdsf-container">
  <div class="mdsf-container mdsf-container-center mdsf-container-middle error-message-container">
    <section class="error-message">
      <h1>404</h1>
      <p>{{ 'site_not_found' | translate }}</p>
      <button class="mdsf-btn"
              (click)="goToHomepage()">
        <i class="fa fa-chevron-right mr-2"></i> {{ 'homepage' | translate }}
      </button>
    </section>
  </div>
</div>
